var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('MdmLink', {
    attrs: {
      "url": _vm.urlPrefix,
      "is-scramble-link": _vm.isScrambleLink
    }
  }, [_c('mdm-icon', {
    staticClass: "icon icon-item livraison",
    attrs: {
      "width": "100",
      "name": "store-delivery"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.free_delivery',
      expression: "'footer.free_delivery'"
    }]
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.all_stores',
      expression: "'footer.all_stores'"
    }],
    staticClass: "font-weight-normal"
  }), _vm._v(" "), _vm.isMarketplaceOpen ? _c('span', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.delivery_disclaimer',
      expression: "'footer.delivery_disclaimer'"
    }],
    staticClass: "delivery-disclaimer font-weight-normal mt-1"
  }) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };